var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6875 10.5C19.6875 5.14844 15.3516 0.8125 10 0.8125C4.64844 0.8125 0.3125 5.14844 0.3125 10.5C0.3125 15.3438 3.82812 19.3672 8.47656 20.0703V13.3125H6.01562V10.5H8.47656V8.39062C8.47656 5.96875 9.92188 4.60156 12.1094 4.60156C13.2031 4.60156 14.2969 4.79688 14.2969 4.79688V7.17969H13.0859C11.875 7.17969 11.4844 7.92188 11.4844 8.70312V10.5H14.1797L13.75 13.3125H11.4844V20.0703C16.1328 19.3672 19.6875 15.3438 19.6875 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.925fd9473d6f461f3465df8c2cf1c155.svg";
export { ForwardRef as ReactComponent };